import { convertDataUrlToBlob, isDataUrl } from './file-upload-url';

/** Util function to ensure all properties required by the backend for the logo data have a default values
 * @param {string} [url] - Data uri of the specified logo image.
 * @param {Object} [options] - Configuration object.
 * @param {string} [options.fileName=logo] - name of the file, required when a data-url is provided for 'url'.
 */

export const getLogoModelFromUrl = (url, options = {}) => {
  const createLogoProperties = ({ type: contentType, size }) => ({
    contentType,
    size,
    fileName: options.fileName || 'logo',
    data: url,
  });

  const extractedProperties = isDataUrl(url)
    ? convertDataUrlToBlob(url)
    : null;

  const logoProperties = extractedProperties
    ? createLogoProperties(extractedProperties)
    : { url };

  return {
    contentType: null,
    data: null,
    fileName: null,
    url: null,
    ...logoProperties,
  };
};
